import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async getCuentasList({ commit, State }, {admin, condo, options}) {
    console.debug('ID: %o', condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/cuentasBancarias/listCondo/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async getCuentaById({ commit, State }, {admin, condo, concepto}) {
    const response = await API.get('/cuentas/get/' + admin.id + '/' + condo.id + '/' + concepto.id);
    return response.data;
  },
  async addCuenta({ commit, State }, {datos}) {
    const response = await API.post('/cuentasBancarias/add/' + datos.admin.id + '/' + datos.condo.id, datos.cuenta);
    return response.data;
  },
   async getBancos({ commit, State }) {
    const response = await API.get('/bancos/list');
    return response.data;
  },
};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
